export default __webpack_public_path__ + "static/media/balance-wellness-creation-how.3611c076.md";